export default function(fields) {
  return {
    ...fields
  }
}
